import React from "react";
import { formatTime } from "../../../utils/date/DateUtils";

function EventItemCard({ eventItem, isLast, onEventClick }) {
  const {
    uuid,
    external_event_id,
    name,
    description,
    news_type,
    news_count = 0,
    event_date,
  } = eventItem;

  return (
    <div
      tabIndex={0}
      role="button"
      className={`rule-item financial-event-row ${isLast ? "no-border" : ""}`}
      onClick={() => onEventClick && onEventClick(eventItem)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 0",
        borderBottom: isLast ? "none" : "1px solid #E5E7EB",
        cursor: "pointer",
        gap: "16px",
      }}
    >
      {/* Left Block */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          flex: 1,
        }}
      >
        {/* Title + Type Badge */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              fontWeight: 400,
              color: "#111827",
              lineHeight: "1.3",
            }}
          >
            {name}
          </span>
        </div>

        {/* Description */}
        {description && (
          <span
            style={{
              fontSize: "13px",
              color: "#6B7280",
              lineHeight: "1.4",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {description}
          </span>
        )}

        {/* Date + News Count inline */}
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          {event_date && (
            <span
              style={{
                fontSize: "12px",
                color: "#9CA3AF",
                fontWeight: 300,
              }}
            >
              {formatTime(event_date)}
            </span>
          )}

          {news_count > 0 && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "12px",
                fontWeight: 300,
                padding: "2px 8px",
                borderRadius: "12px",
                backgroundColor: "#EFF6FF",
                color: "#6B7280",
              }}
            >
              {news_count} {news_count === 1 ? "news" : "news"}
              {/* Right Navigation Arrow */}
              <div
                className="financial-event-arrow-icon"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  width: "24px",
                  height: "24px",
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/icons/arrow_right_alt.svg`}
                  alt="View related news"
                  style={{ width: "16px", height: "16px", opacity: 0.6 }}
                />
              </div>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default EventItemCard;
